import { render, staticRenderFns } from "./SpatialNavigation.vue?vue&type=template&id=1a2ed043&scoped=true&"
import script from "./SpatialNavigation.vue?vue&type=script&lang=js&"
export * from "./SpatialNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ed043",
  null
  
)

export default component.exports